module.exports = __webpack_public_path__ + "static/media/background-8.4df9eaf9.jpg";